<template>
  <v-card
    class="mx-auto process-wrapper"
    flat
    width="450"
    max-width="450"
    :to="{ name: this.process.route }"
  >
    <div class="gallery-cell">
      <v-img class="galery-item" :src="image" max-width="240px" height="220px" />
    </div>

    <div class="titles mt-2 ml-4 mb-0">
      <b>{{ process.name }}</b>
      <p class="pt-3 body-2 grey-2">
        {{ process.subtitle }}
      </p>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "ProcessCell",
  props: {
    process: Object
  },
  computed: {
    image() {
      return require(`../../assets/images/${this.process.image}`);
    }
  }
};
</script>

<style lang="scss">
// #process-card {
//   .v-image {
//     .v-image__image--cover {
//       transform: translateZ(0);
//       transition: all 0.3s cubic-bezier(0.34, 1.61, 0.7, 1);
//     }
//   }
// }
// #process-card:hover {
//   .v-image {
//     .v-image__image--cover {
//       transform: translate3d(0, -30px, 0);
//     }
//   }
// }
//
</style>
<style lang="scss" scoped>
.gallery-cell {
  overflow: hidden;
  min-width: 240px !important;
}
.galery-item {
  transition: all 0.3s ease-out;
}
.galery-item::after {
  position: absolute;
  display: block;
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 240px !important;
  opacity: 0;
  content: "";
}

.galery-item:hover {
  transform: scale(1.1);
  &::after {
    opacity: 1;
  }
}
.process-wrapper {
  display: flex;
  margin-top: 32px;
  margin-left: 16px;
  padding-right: 12px;
}
.body-2 {
  opacity: 0.8;
  font-size: 14px !important;
  line-height: 16px !important;
}
@media (max-width: 960px) {
  .process-wrapper {
    padding-right: 0px;
    max-width: 250px !important;
    align-items: center;
    flex-direction: column;
  }
}
</style>
